<template>
  <div class="bg" data-type="bg">
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <!-- <div class="optimized">
        <div :class="{'horizontal': true,
            'hover': optimized == 1? false : true,
            'active': optimized == 1,}"
          @click="optimized = 1;
          materialPushAnalysis({type: 'bgLandscape'});">
          横版
        </div>
        <div :class="{'Vertical': true,
            'hover': optimized == 2? false : true,
            'active': optimized == 2,}"
          @click="optimized = 2; materialPushAnalysis({type: 'bgPortrait'});">
          竖版
        </div>
      </div>-->

      <div class="btnsGrid">
        <div class="bg-tab">
          <div
            :class="{
              'material-btn': true,
              active: bgTypeFlag == 1,
              hover: bgTypeFlag == 2,
            }"
            @click="switchBgType(1)"
          >
            背景素材
          </div>
          <div
            :class="{
              'color-btn': true,
              active: bgTypeFlag == 2,
              hover: bgTypeFlag == 1,
            }"
            @click="switchBgType(2)"
          >
            背景色
          </div>
        </div>

        <div class="optimized" v-show="bgTypeFlag == 1">
          <span>
            <font>{{
              optimized == 1 ? "横版" : "" + optimized == 2 ? "竖版" : ""
            }}</font>
            <div></div>
          </span>
          <!-- <span v-if="optimized == 1">

        </span>
        <span v-if="optimized ==2">

          </span>-->

          <div class="selector">
            <div
              @click="
                optimized = 1;
                materialPushAnalysis({ type: 'bgLandscape' });
              "
              :class="{ horizontal: true, active: optimized == 1 }"
            >
              横版
            </div>

            <div
              @click="
                optimized = 2;
                materialPushAnalysis({ type: 'bgPortrait' });
              "
              :class="{ Vertical: true, active: optimized == 2 }"
            >
              竖版
            </div>
          </div>
        </div>
      </div>

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id + index + Math.random()"
        :class="{ operation: (dataArray['_' + item.id] || {}).judge }"
        :style="{
          height: (dataArray['_' + item.id] || {}).judge ? 'auto' : '146px',
        }"
      >
        <sectionCategory
          :itemData="item"
          :itemIndex="index"
          :boxName="boxName"
          @scrollTop="scrollTop"
          @getData="getData"
          @dataBoxAction="dataBoxAction"
        />

        <div
          class="body-list"
          :style="{
            height: ((dataArray['_' + item.id] || {}).data || {}).length
              ? dataArray['_' + item.id].WFSheight + 30 + 'px'
              : '150px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top': ((dataArray['_' + item.id] || {}).data || {}).length
              ? dataArray['_' + item.id].WFSheight - 10 + 'px'
              : '50px',
          }"
        >
          <!-- <FilterSprites
            v-model  = "dataArray['_' + item.id]"
            :boxName = 'boxName'
            :cgid    = "'_' + item.id"
            :dataArray  = 'dataArray'
            :loading="loading"
          />-->

          <div
            class="item"
            v-if="dataArray['_' + item.id]"
            v-for="(itemL, indexL) in (dataArray['_' + item.id] || {}).data"
            @mouseover="getCharacters($event, itemL)"
            @mouseout="closeCharacters()"
            @click="
              settingScenesBg(itemL);
              materialPushAnalysis({
                type: 'bg',
                id: item.id,
                name: item.name,
              });
            "
            :key="itemL.id + indexL + Math.random()"
            :style="{
              top: itemL.topWFC - 56 + 'px',
              left: itemL.leftWFC + 'px',
              height: itemL.direction
                ? itemL.direction == 2
                  ? '223px'
                  : '75px'
                : '75px',
              // width: itemL.direction ? (itemL.direction == 2 ? '78px' : '130px') :'130px',
              width: '130px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              :style="{
                height: '100%',
                width: itemL.direction
                  ? itemL.direction == 2
                    ? '100%'
                    : 'auto'
                  : 'auto',
              }"
            />
            <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
            <payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>
            <span
              @mouseover="stopDocument($event)"
              class="label labelVideo el-icon-caret-right"
              style="right: 0; left: 5px; width: 18px; border-radius: 100%"
              v-if="itemL.fileType == 25"
            ></span>

            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 47px"
          ></div>
        </div>

        <div class="bottom-more">
          <div class="btn" @click="callSpriteLib()">更多背景</div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg == 'bg'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />
    </div>

    <div class="colorPickerGrid" v-show="bgTypeFlag == 2 && !S_GlobalSearch">
      <ColorPickerSlide
        @colorChanged="setBackground"
        :boxName="boxName"
      ></ColorPickerSlide>
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="settingScenesBg"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";
import ColorPickerSlide from "./colorPickerSlide.vue";
import map from "lodash/map";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      bgTypeFlag: 1, //1:背景素材 2：背景颜色
      boxName: "bg", // 素材盒子的名字
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度 - 38(横竖版按钮高度)
        Incremental: 120, // 单个分类的高度
        material: 90, // 单个元素的高度
        custom: 50, // 自定义高度
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 3,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 2, // 瀑布流的列数
      },
      colorBtns: [
        { color: "#000000" },
        { color: "#ffea01" },
        { color: "#5778fb" },
        { color: "#ff1844" },
        { color: "#ff6a0e" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "Window_Size",
      "SelectScenes_Msg",
    ]),
  },
  mounted() {
    const vm = this;
    this.$bus.on("upload_vue", (data) => {
      // 上传完成的发出事件
      if (data.type === "image") {
        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "在这里可以看到上传的图片。",
          position: {
            top: "250px",
            left: `${this.MaterialPane_Size.width + 15}px`,
          },
        });

        let scenesData = null;
        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "在这里可以看到上传的图片。",
          position: {
            top: "250px",
            left: `${this.MaterialPane_Size.width + 15}px`,
          },
        });
        if (data.name === "imagePic") {
          scenesData = {};
          scenesData.fileType = 1;

          if (data.data.length == 1) {
            data.data = data.data[0];
            scenesData.url = data.data.filename;
            scenesData.title = data.fileName || data.title;
            scenesData.thumbnailUrl = data.data.thumbnailName;
            this.settingScenesBg({
              id: null,
              url: scenesData.url,
              fileType: null,
            });
          } else {
            scenesData.url = "";
            scenesData.title = "";
            scenesData.thumbnailUrl = "";
            for (let j = 0; j < data.data.length; j++) {
              let comma = ",";
              if (j == data.data.length - 1) {
                comma = "";
              }
              scenesData.url += data.data[j].filename + comma;
              scenesData.title += data.data[j].title + comma;
              scenesData.thumbnailUrl += data.data[j].thumbnailName + comma;
            }
          }
          this.materialPushAnalysis({ type: "bgUpload" });
        } else if (data.name === "videoAndImage") {
          scenesData = {};
          scenesData.fileType = 1;
          scenesData.url = data.data.filename;
          scenesData.title = data.file.name;
          scenesData.thumbnailUrl = data.data.thumbnailName;

          this.settingScenesBg({
            id: null,
            url: scenesData.url,
            fileType: null,
          });
        }

        if (!scenesData) return;
        this.$http
          .post("/api/user/pic/multiples", scenesData)
          .then((resScenes) => {
            let materials = resScenes.data.data;
            materials = map(materials, (v) => v);
            this.$bus.emit("collectPersonal_vue", { data: "collectPic" });
            this.$bus.emit("relateMaterialDone", {
              materials: [].concat(materials),
              materialTypeName: "pic",
              multi: true,
            });
          })
          .catch((Serror) => {
            console.log(Serror, "失败");
          });
      }
    });

    this.$bus.on("open-bg-color", (data) => {
      vm.bgTypeFlag = 2;
      this.$bus.emit("materialPane_vue", { type: "bg" });
    });
  },
  created() {
    // this.$bus.on('eyedropperBox.prepareStart', () => {
    //   this.eyedropperWaitingStart();
    // });
    // this.$bus.on('eyedropperBox.ready', () => {
    //   this.eyedropperWaitingEnd();
    // });
  },
  methods: {
    colorBg(el, { posy } = {}) {
      // 颜色背景设置
      this.$bus.emit("FeaturesPop_vue", {
        name: "color",
        posx: this.TopNav_Size.width + 50,
        posy: posy || el.clientY + 35,
        scenes: true,
        type: 1,
      });
      // this.$store.commit('del_vipSprites', {id : 'BG-'+this.SelectScenes_Msg.id});
    },
    imgErroeFs(e, data) {
      if (data.url) {
        e.srcElement.src = this.$handleAssetsUrl(data.url);
      }
    },
    // onEyedropperBtnClicked (ev) {
    //   if (this.$refs.eyedropperBtn.classList.contains('el-icon-loading')) {
    //     return;
    //   }
    //   this.$bus.emit('eyedropperStart');
    //   this.colorBg(ev);
    //   this.$analysis({
    //     category:'resource_background', action:'click_background_color_picker', label:'资源设置_背景_取色器'
    //   });
    // },
    // eyedropperWaitingStart () {
    //   this.$refs.eyedropperBtn.classList.remove('icon-eyedropper');
    //   this.$refs.eyedropperBtn.classList.add('el-icon-loading');
    // },
    // eyedropperWaitingEnd () {
    //   this.$refs.eyedropperBtn.classList.remove('el-icon-loading');
    //   this.$refs.eyedropperBtn.classList.add('icon-eyedropper');
    // },
    setColorBackground(hex) {
      let sceneBgProps = this.SelectScenes_Msg.background;
      let sceneBgData = sceneBgProps.data.data || {};
      let bgOpts = {
        // 设置场景背景
        resourceId: null, // 背景资源id
        fileType: null, // 背景资源type
        type: "Color", // 背景类型 0:Color 1:Image 2:Video
        data: {
          // 颜色背景的数据
          color: hex, // 颜色值,8位数
          blur: 0, // 高斯模糊
          opacity: 1, // 高斯模糊参数
        },
        zoomActive: false,
      };
      if (this.BgOperation === "swap") {
        bgOpts.data = {
          ...bgOpts.data,
          blur: sceneBgData.blur,
          opacity: sceneBgData.opacity,
        };
        bgOpts.zoomActive = sceneBgProps.zoomActive;
        bgOpts.zoomOptions = sceneBgProps.zoomOptions;
      }
      this.SelectScenes_Msg.setBackground(bgOpts, null, true);
      if (this.BgOperation === "swap") {
        this.$store.commit("save_BgOperation", "add");
      }
    },
    setBackground(item) {
      if (item.type == "Solid") {
        this.setColorBackground(item.color);
      } else if (item.type == "Gradient") {
        this.settingScenesBg(item);
      }
    },
    switchBgType(type) {
      this.bgTypeFlag = type;
      if (this.bgTypeFlag == 2) {
        this.$emit("switchSettingPane", "color");
      } else {
        this.$emit("switchSettingPane", "bgLib");
      }
    },
  },
  components: {
    Search,
    ColorPickerSlide,
    PayTypeSubscript,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bg {
  position: relative;
  width: 270px;
  border-radius: 8px;

  .colorPickerGrid {
    position: absolute;
    top: 50px;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }

  .btnsGrid {
    position: relative;
    width: 100%;
    height: 36px;
    margin-bottom: 5px;

    .optimized {
      position: absolute;
      right: 6px;
      width: 72px;
      height: 38px;
      color: #474261;
      font-size: 12px;
      background: #fff;
      cursor: pointer;

       > span {
        position: absolute;
        right: 0;
        display: inline-block;
        line-height: 38px;
         > div {
          display: inline-block;
          width: 8px;
          height: 8px;
          border: 1px solid #474261;
          border-top: none;
          border-left: none;
          transform: rotate(45deg) translateY(-50%);
        }
      }

      .selector {
        position: absolute;
        top: 36px;
        left: 10px;
        z-index: 50;
        display: none;
        width: 72px;
        height: 64px;
        background-color: #fff;
        box-shadow: 0 0 4px 0 rgba(54, 76, 204, .4);
        border-radius: 4px;
        .horizontal,
        .Vertical {
          height: 32px;
          line-height: 32px;
        }
        .horizontal {
          border-radius: 4px 4px 0 0;
        }
        .Vertical {
          border-radius: 0 0 4px 4px;
        }
        .active {
          background-color: #f0f0f8;
        }

        &:before {
          content: "";
          position: absolute;
          top: -16px;
          left: 50%;
          z-index: 12;
          display: block;
          box-sizing: content-box;
          width: 0;
          height: 0;
          padding: 0;
          border-top: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 8px solid #fff;
          border-left: 8px solid transparent;
          transform: translateX(-50%);
        }
        &:after {
          content: "";
          position: absolute;
          top: -18px;
          left: 50%;
          z-index: 10;
          display: block;
          box-sizing: content-box;
          width: 0;
          height: 0;
          padding: 0;
          border-top: 9px solid transparent;
          border-right: 9px solid transparent;
          border-bottom: 9px solid rgba(54, 76, 204, .2);
          border-left: 9px solid transparent;
          transform: translateX(-50%);
        }
      }
    }

    .optimized:hover .selector {
      display: block;
    }

    .bg-tab {
      position: absolute;
      width: 144px;
      height: 36px;
      margin-left: 0;
      background: #fff;
      cursor: pointer;
      .material-btn,
      .color-btn {
        position: absolute;
        top: 0;
        width: 72px;
        height: 36px;
        color: #000;
        line-height: 36px;
        text-align: center;
        border: 1px solid #d4d4e7;
        transition: all .3s;
      }
      .material-btn {
        left: 0;
        border-right: 0;
        border-radius: 4px 0 0 4px;
      }
      .color-btn {
        right: 0;
        border-left: 0;
        border-radius: 0 4px 4px 0;
      }
      .active {
        color: #fff;
        background: #5778fb;
        border-color: #5778fb;
      }
      .hover {
        &:hover {
          color: #fff;
          background: #95a8f3;
        }
      }
    }
  }

  .collect-bg {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 270px;
    height: 55px;
    padding-top: 15px;
    padding-bottom: 15px;

    .add-icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      margin-right: 14px;
      color: #fff;
      background-color: #5778fb;
      border-radius: 50%;
      cursor: pointer;
    }

    .bg-color {
      position: absolute;
      top: 10px;
      left: 70px;
      width: 80px;
      height: 30px;
      background-color: #5778fb;
      border: solid 1px #d8d8e5;
    }

    span {
      color: #474261;
    }
  }
  .add-bg {
    position: relative;
    width: 100%;
    height: 35px;
    cursor: pointer;

    div {
      width: 150px;
      height: 35px;
      margin: 0 auto;
      margin-top: 20px;
      color: #fff;
      line-height: 35px;
      text-align: left;
      text-indent: 45px;
      background-color: #a3a6cd;
      border-radius: 17px;
      transition: all .3s;
      cursor: pointer;

      &:hover {
        background-color: #5778fb;
      }
    }
  }

  .data-body {
    overflow: hidden;
    height: 146px;
    padding: 19px 0;

    .body-list {
      position: relative;
      min-height: 88px;
      border-top: 2px solid #d4d4e7;
      &:before {
        content: "";
        position: absolute;
        top: -6px;
        right: 0;
        left: 0;
        width: 10px;
        height: 10px;
        margin: 0 auto;
        background: #fff;
        border-top: 2px solid #d4d4e7;
        border-right: 2px solid #d4d4e7;
        transform: rotate(135deg);
      }

      .item {
        position: absolute;
        overflow: hidden;
        width: 130px;
        background-color: #fafafd;
        border: solid 2px #dbdff0;
        border-radius: 3px;
        cursor: pointer;
        &:hover {
          border-color: #5778fb;
        }

         > img {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 0;
          max-width: 100%;
          max-height: 100%;
          margin: auto;
        }

        .modify,
        .label {
          position: absolute;
          right: 5px;
          bottom: 5px;
          width: 30px;
          height: 18px;
          color: #fff;
          line-height: 18px;
          background: #d83d60;
          border-radius: 5px;
        }
        .labelVideo {
          background: #595574;
        }
        .modify {
          width: 35px;
          height: 35px;
          background-image: url("../../../../static/svg/edit-display-white.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: 20px 18px;
          transition: all .3s;
          cursor: pointer;
          opacity: 0;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
    }
  }
}

.color-btns {
  display: flex;
  justify-content: space-between;
  padding-top: 14px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d4d4e7;
}

.color-btn {
  width: 40px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
  &.trigger {
    background: conic-gradient(
    #ff7e00 0%,
    #ff4040 16%,
    #ff3feb 32%,
    #2d46ff 48%,
    #2dfcff 64%,
    #00ff12 81%,
    #80fe09 84%,
    #fffc00 100%
    );
  }
}

@import "./slide.scss";
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/bg.vue